/**
 * Funnel Query Keys - Core SDK (Framework-agnostic)
 * Standardized query keys for caching funnel data
 * Can be used with any query library (TanStack Query, SWR, etc.)
 */

/**
 * Query keys for funnel operations
 * These keys are used for caching and invalidation strategies
 */
export const funnelQueryKeys = {
    /**
     * Key for a specific funnel session
     */
    session: (sessionId: string) => ['funnel', 'session', sessionId] as const,

    /**
     * Key for all funnel sessions
     */
    allSessions: () => ['funnel', 'sessions'] as const,

    /**
     * Key for funnel metadata/configuration
     */
    funnelMeta: (funnelId: string) => ['funnel', 'meta', funnelId] as const,
};







